import React, { useEffect } from "react";
import { logoutApp } from "../../../global/context/action/auth/logoutApp";
import { useHistory } from "react-router";
import { useContext, useState } from "react";
import { PortalContext } from "../../context/Provider";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import {
  desvinculaSocial,
  logoutPacienteDefault,
  vinculaSocial,
  setUserSelectEditar,
} from "../../context/Actions/paciente/paciente";
import { logoutAccessToken } from "../../context/Actions/token/accessToken";
import { logoutPacientePerfil } from "../../context/Actions/paciente/paciente";
import {
  editaPerfil,
  finalizaEdicion,
  resetPaciente,
  wsPostEditarPaciente,
  wsPutAceptaWsp,
} from "../../context/Actions/paciente/paciente";
import { wsGetDatosPaciente } from "../../context/Actions/paciente/paciente";
import { wsGetGrupoFamiliar } from "../../context/Actions/grupoFamiliar/grupoFamiliar";
import { logoutRegistro } from "../../context/Actions/registro/logoutRegistro";
import { IonSpinner } from "@ionic/react";
import { resetMultitab } from "../../context/Actions/multiTab/multiTab";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import {
  localidad,
  localidadReset,
} from "../../context/Actions/localidad/localidad";
import { misMedicosReset } from "../../context/Actions/misMedicos/misMedicos";
import { misInformesReset } from "../../context/Actions/misInformes/misInformes";
import { misLaboratoriosReset } from "../../context/Actions/misLaboratorios/misLaboratorios";
import { resetTurnosPaciente } from "../../context/Actions/turnos/turnosPaciente";
import { grupoFamiliarReset } from "../../context/Actions/grupoFamiliar/grupoFamiliar";
import { resetLaboGrupo } from "../../context/Actions/laboGrupo/laboGrupo";
import { resetEstudioGrupo } from "../../context/Actions/estudioGrupo/estudioGrupo";
import { resetListaFamiliares } from "../../context/Actions/listaFamiliares/listasFamiliares";
import { recetasDigitalesReset } from "../../context/Actions/turnos/recetaDigital";
import { resetDropdown } from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { GlobalContext } from "../../../global/context/Provider";
import { SignInWithApple } from "@capacitor-community/apple-sign-in";
import { obraSocial } from "../../context/Actions/obraSocial/obraSocial";
import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";
import { isMobile } from "global/utils/platformDetector";
import EditarMobileIcon from "../../assets/images/generico/EditarMobileIcon";
import decodeJWT from "../../../global/utils/decodeJWT";
import camelize from "../../../global/utils/camelize";
import CardSocial from "../../components/Perfil/CardSocial/CardSocial";
import CardNotificaciones from "../../components/Perfil/CardFamiliar/CardNotificaciones/CardNotificaciones";
import ProfileColumn1 from "../../components/Perfil/PerfilDatosPersonales/ProfileColumn1";
import CardFamiliar from "../../components/Perfil/CardFamiliar/CardFamiliar";
import CardPerfil from "../../components/Perfil/CardPerfil/CardPerfil";
import Modal from "../../components/Genericos/Modal/Modal";
import Loading from "../../components/Genericos/Loading/Loading";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import defaultPerfil from "../../assets/images/generico/defaultUserImage.png";
import CameraIcon from "../../assets/images/generico/CameraIcon";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import BtnVolver from "../../components/Genericos/BtnVolver/BtnVolver";
import Dropdown from "../../components/Genericos/Dropdown/Dropdown";
import { dropdownFamiliares } from "../../components/Turnos/ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { BodyContainer, ContainerScroll } from "./localStyle";
import "./PerfilStyle.css";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const Perfil = () => {
  const {
    modalDispatch,
    registroState,
    registroDispatch,
    pacienteDispatch,
    pacienteState,
    modalState,
    tokenGoogleDispatch,
    tokenGoogleState,
    multiTabDispatch,
    ayudaDispatch,
    localidadState,
    localidadDispatch,
    misMedicosDispatch,
    misInformesDispatch,
    misLaboratoriosDispatch,
    turnosPacienteDispatch,
    grupoFamiliarDispatch,
    laboGrupoDispatch,
    estudioGrupoDispatch,
    listaFamiliaresDispatch,
    listaFamiliaresState,
    recetasDigitalesDispatch,
    selectDropDownDispatch,
    obraSocialState,
    obraSocialDispatch,
  } = useContext(PortalContext);

  // Nuevo contexto
  const {
    authState,
    authDispatch,
    toasterDispatch,
    toasterState,
    configState,
  } = useContext(GlobalContext);

  const history = useHistory();
  const [desvincularGoogle, setDesvincularGoogle] = useState(false);
  const [desvincularApple, setDesvincularApple] = useState(false);
  const [modificaPerfilClass, setModificaPerfilClass] = useState("");
  const [modificaHeadBannerClass, setModificaHeadBannerClass] = useState("");
  const [guardarPerfil, setGuardarPerfil] = useState(false);
  const [imgPerfil, setImgPerfil] = useState(null);
  const [linkingGoogle, setLinkingGoogle] = useState(false);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const EditarPerfil = () => {
    if (!guardarPerfil) {
      let enablePerfilForm = true;
      editaPerfil(enablePerfilForm)(pacienteDispatch);
      setGuardarPerfil(true);
      setModificaPerfilClass("ptur-perfil-usuario-bannerIn");
      setModificaHeadBannerClass("ptur-perfil-usuario-bannerHeaderIn");
    } else {
      logoutRegistro()(registroDispatch);
      obtenerDatosPaciente();
      finalizaEdicion()(pacienteDispatch);
      setGuardarPerfil(false);
      setModificaPerfilClass("ptur-perfil-usuario-bannerOut");
      setModificaHeadBannerClass("");
    }
  };

  const guardarCambiosPerfil = () => {
    let aux = pacienteState.paciente.editaPerfil.editarPaciente;
    let auxError = registroState.registro.listError;
    let flgFormOk = false;
    for (const item in auxError) {
      if (auxError[item] === true) {
        flgFormOk = true;
      }
    }
    if (!flgFormOk) {
      finalizaEdicion()(pacienteDispatch);
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        wsPostEditarPaciente(
          aux,
          pacienteState.paciente.userSelect.pacienteSeleccionado.id
        )(pacienteDispatch);
      } else {
        wsPostEditarPaciente(aux)(pacienteDispatch);
      }
    } else {
      showToaster(
        {
          texto: "Complete los campos obligatorios",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  // mejorar este useEffect,
  useEffect(() => {
    if (
      pacienteState.paciente.data !== null &&
      !pacienteState.paciente.loading
    ) {
      setGuardarPerfil(false);
      setModificaPerfilClass("ptur-perfil-usuario-bannerOut");
      setModificaHeadBannerClass("");
      if (
        pacienteState.paciente.error !== null &&
        pacienteState.paciente.data !== null
      ) {
        showToaster(
          {
            texto: "Cambios guardados exitosamente",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        //mediante este if agregado evito volver a hacer getdatospaciente cuando vinculo o desvinculo.
        if (
          pacienteState.paciente.data !== null &&
          pacienteState.paciente.data !== undefined &&
          pacienteState.paciente.data !== "" &&
          pacienteState.paciente.data.origen !== "vinculaSocial" &&
          pacienteState.paciente.data.origen !== "desvinculaSocial"
        ) {
          obtenerDatosPaciente();
        }
        resetPaciente()(pacienteDispatch);
      }
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.data]);

  useEffect(() => {
    if (
      pacienteState.paciente.error !== undefined &&
      pacienteState.paciente.error !== null &&
      pacienteState.paciente.error !== false
    ) {
      if (pacienteState.paciente.error.origen !== "cambioClave") {
        showToaster(
          {
            texto:
              typeof pacienteState.paciente.error.detalle !== "object"
                ? pacienteState.paciente.error.detalle
                : "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);

        resetPaciente()(pacienteDispatch);
        setGuardarPerfil(false);
        setModificaPerfilClass("ptur-perfil-usuario-bannerOut");
        setModificaHeadBannerClass("");
      }
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.error]);

  useEffect(() => {
    if (
      pacienteState.paciente.cambioClave !== null &&
      pacienteState.paciente.cambioClave !== undefined &&
      pacienteState.paciente.cambioClave !== "" &&
      pacienteState.paciente.cambioClave?.origen === "cambioClave"
    ) {
      setGuardarPerfil(false);
      setModificaPerfilClass("ptur-perfil-usuario-bannerOut");
      setModificaHeadBannerClass("");
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.cambioClave]);

  const nameCamelized = () => {
    let name = pacienteState.paciente.datosActualizados.nombre;
    return camelize(name);
  };

  // ⚠️ NOTA: Esta función está disponible para implementar un botón de logout en el perfil
  // El logout actualmente se maneja desde el BurguerMobile (menú hamburguesa)
  // eslint-disable-next-line no-unused-vars
  const handleClickLogout = () => {
    if (authState.authTraza.data !== null) {
      wsPostLogoutTraza(authState.authTraza.data.id, {
        ingreso: false,
        sector: configState.config.data.sectorTurno,
      })(authDispatch);
    }
    hideModal()(modalDispatch);
    logoutPacienteDefault()(pacienteDispatch);
    logoutApp(history)(authDispatch);
    misMedicosReset()(misMedicosDispatch);
    misInformesReset()(misInformesDispatch);
    misLaboratoriosReset()(misLaboratoriosDispatch);
    resetTurnosPaciente()(turnosPacienteDispatch);
    grupoFamiliarReset()(grupoFamiliarDispatch);
    localidadReset()(localidadDispatch);
    resetMultitab()(multiTabDispatch);
    resetLaboGrupo()(laboGrupoDispatch);
    resetEstudioGrupo()(estudioGrupoDispatch);
    resetListaFamiliares()(listaFamiliaresDispatch);
    recetasDigitalesReset()(recetasDigitalesDispatch);
    resetDropdown()(selectDropDownDispatch);
  };

  const onClickVinculaGoogle = async () => {
    if (linkingGoogle) return; // evita posts concurrentes
    setLinkingGoogle(true);

    const yaVinculado = !!pacienteState.paciente?.datosActualizados?.gmail_id;
    if (yaVinculado) {
      try {
        await desvinculaSocial("GOOGLE")(pacienteDispatch);
      } finally {
        setLinkingGoogle(false);
      }
      return;
    }

    try {
      const googleUser = await GoogleAuth.signIn();
      const idToken = googleUser?.authentication?.idToken;
      if (!idToken) {
        showToaster(
          {
            texto: "Error al obtener idToken de Google!",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        return;
      }

      // usa el idToken como tokenRedSocial
      vinculaSocial(
        googleUser.id, // id
        "GOOGLE", // red
        authState.auth.data.token, // token (tu JWT)
        idToken // tokenRedSocial = idToken
      )(pacienteDispatch);
    } catch (e) {
      showToaster(
        {
          texto: "Ocurrió un error al vincular Google!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      // Restaurar el toggle a su posición original
      setDesvincularGoogle(false);
      setDesvincularGoogle(true);
    } finally {
      setLinkingGoogle(false);
    }
  };

  //proceso de Vinculacion de Google
  const onClickVinculaApple = () => {
    if (
      pacienteState.paciente.datosActualizados.apple_id !== "" &&
      pacienteState.paciente.datosActualizados.apple_id !== null &&
      pacienteState.paciente.datosActualizados.apple_id !== undefined
    ) {
      let appleRedSociaL = "APPLE";
      desvinculaSocial(appleRedSociaL)(pacienteDispatch);
    } else {
      //configuro la autorizacion.
      let options = {
        clientId: isMobile
          ? "ar.com.dim.portalturnos"
          : "ar.com.dim.portalturnos.sid",
        redirectURI: "https://portalnuevo.dim.com.ar/",
        scopes: "email",
        state: "12345",
        nonce: "nonce",
      };
      // js puro como explica la libreria.
      SignInWithApple.authorize(options)
        .then((result) => {
          if (result !== undefined && result !== null) {
            let payloadToken = decodeJWT(result.response.identityToken);
            vinculaSocial(
              payloadToken.sub,
              "APPLE",
              authState.auth.data.token,
              result.response.identityToken
            )(pacienteDispatch);
          }
        })
        .catch((error) => {
          if (error !== undefined && error !== null) {
            showToaster(
              {
                texto: "Error al ingresar a través de Apple!",
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
            //obligo al state a escuchar el cambio
            setDesvincularApple(false);
            setDesvincularApple(true);
          }
        });
    }
  };

  const modalCambioDeImagen = () => {
    showModal(
      "Perfil/ModalFotoPerfil/ModalFotoPerfil",
      {
        titulo: "Cambio de Foto de Perfil",
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const handleClickAgregaFamiliar = () => {
    hideModal()(modalDispatch);
    logoutPacienteDefault()(pacienteDispatch);
    history.push("/GrupoFamiliar");
  };

  //utilizado solamente para la validacion nativa.
  useEffect(() => {
    if (
      tokenGoogleState.tokenGoogle.data !== null &&
      tokenGoogleState.tokenGoogle.data !== undefined &&
      tokenGoogleState.tokenGoogle.data !== false
    ) {
      vinculaSocial(
        "",
        "GOOGLE",
        authState.auth.data.token,
        tokenGoogleState.tokenGoogle.data.data.access_token
      )(pacienteDispatch);
    } else if (
      tokenGoogleState.tokenGoogle.error !== null &&
      tokenGoogleState.tokenGoogle.error !== undefined &&
      tokenGoogleState.tokenGoogle.error !== false
    ) {
      showToaster(
        {
          texto: "Error al vincular Google!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      setDesvincularGoogle(true);
    }
    //eslint-disable-next-line
  }, [tokenGoogleState]);

  const onClickAceptaWsp = () => {
    if (pacienteState.paciente.datosActualizados.aceptaAlertaWapp) {
      let boolOk = false;
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        wsPutAceptaWsp(
          boolOk,
          pacienteState.paciente.userSelect.pacienteSeleccionado.id
        )(pacienteDispatch);
      } else {
        wsPutAceptaWsp(boolOk)(pacienteDispatch);
      }
    } else {
      let boolNo = true;
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        wsPutAceptaWsp(
          boolNo,
          pacienteState.paciente.userSelect.pacienteSeleccionado.id
        )(pacienteDispatch);
      } else {
        wsPutAceptaWsp(boolNo)(pacienteDispatch);
      }
    }
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const obtenerDatosPaciente = () => {
    if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
      wsGetDatosPaciente(
        pacienteState.paciente.userSelect.pacienteSeleccionado.id,
        false
      )(pacienteDispatch);
    } else {
      wsGetDatosPaciente(-1, false)(pacienteDispatch);
    }
  };

  useEffect(() => {
    if (registroState.registro.usuario.solicitaRedSoc) {
      //cierro lo que tiene que ver con el logueo por vinculacion.
      logoutRegistro()(registroDispatch);
      logoutAccessToken()(tokenGoogleDispatch);
    }
    //eslint-disable-next-line
  }, [registroState.registro.usuario]);

  useEffect(() => {
    if (
      pacienteState.paciente.data !== null &&
      pacienteState.paciente.data !== undefined &&
      pacienteState.paciente.data !== "" &&
      pacienteState.paciente.data.origen === "vinculaSocial"
    ) {
      showToaster(
        {
          texto: "La cuenta ha sido vinculada con éxito",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      obtenerDatosPaciente();
      logoutPacientePerfil()(pacienteDispatch);
    } else if (
      pacienteState.paciente.data !== null &&
      pacienteState.paciente.data !== undefined &&
      pacienteState.paciente.data !== "" &&
      pacienteState.paciente.data.origen === "desvinculaSocial"
    ) {
      showToaster(
        {
          texto: "La cuenta ha sido desvinculada con éxito!",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      hideModal()(modalDispatch);
      obtenerDatosPaciente();
      logoutPacientePerfil()(pacienteDispatch);
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.data]);

  useEffect(() => {
    if (
      pacienteState.paciente.error !== null &&
      pacienteState.paciente.error !== undefined &&
      pacienteState.paciente.error !== false &&
      pacienteState.paciente.error !== "" &&
      pacienteState.paciente.error.origen === "vinculaSocial"
    ) {
      setTimeout(() => {
        showToaster(
          {
            texto: "Ocurrió un error al vincular la cuenta",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }, 50);
    } else if (
      pacienteState.paciente.error !== null &&
      pacienteState.paciente.error !== undefined &&
      pacienteState.paciente.error !== "" &&
      pacienteState.paciente.error.origen === "desvinculaSocial"
    ) {
      setTimeout(() => {
        showToaster(
          {
            texto: "Ocurrió un error al desvincular la cuenta",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }, 50);
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.error]);

  useEffect(() => {
    GoogleAuth.initialize({
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      scopes: ["profile", "email"],
      grantOfflineAccess: null,
    });
    // comente para probar la version 1.0
    if (pacienteState.paciente.datosActualizados !== null) {
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        setImgPerfil(
          pacienteState.paciente.userSelect.pacienteSeleccionado.paciente
            .imagenPerfil
        );
      } else {
        setImgPerfil(pacienteState.paciente.datosActualizados.imagenPerfil);
      }
    }
    if (localidadState.localidad.data === null) {
      localidad()(localidadDispatch);
    }
    if (obraSocialState.obraSocial.data === null) {
      obraSocial()(obraSocialDispatch);
    }
    obtenerDatosPaciente();
    logoutRegistro()(registroDispatch);
    hideAyuda()(ayudaDispatch);
    displayAyuda("hidden");
    setTimeout(() => {
      displayAyudaMobile("hidden");
    }, 250);
    //eslint-disable-next-line
  }, []);

  //useEffect cambio de imagen. //tanto cambio de familiar como cambio de imagen.
  useEffect(() => {
    if (pacienteState.paciente.datosActualizados !== null) {
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        setImgPerfil(
          pacienteState.paciente.userSelect.pacienteSeleccionado.paciente
            .imagenPerfil
        );
      } else {
        setImgPerfil(pacienteState.paciente.datosActualizados.imagenPerfil);
      }
    }
  }, [pacienteState.paciente.datosActualizados]);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };
  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  // Lógica de selección de familiares
  const pacienteAuth = authState?.auth?.data?.paciente;

  const onPerfilFamiliaresChange = (e) => {
    const idUser = pacienteAuth?.codigo;

    if (!idUser) {
      setUserSelectEditar(false)(pacienteDispatch);
      return;
    }

    if (e !== "") {
      if (idUser === e.id) {
        // Usuario seleccionó su propio perfil
        setUserSelectEditar(false)(pacienteDispatch);
        wsGetDatosPaciente(-1, false)(pacienteDispatch); // Cargar datos del usuario principal directamente
      } else if (e.edicionPerfil && idUser !== e.id) {
        // Usuario seleccionó un familiar CON permisos de edición
        setUserSelectEditar({ id: e.id, paciente: e.paciente })(
          pacienteDispatch
        );
        wsGetDatosPaciente(e.id, false)(pacienteDispatch); // Cargar datos del familiar seleccionado DIRECTAMENTE con su ID
      } else if (!e.edicionPerfil && idUser !== e.id) {
        // Usuario seleccionó un familiar SIN permisos de edición
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro"
        )(modalDispatch);
        setUserSelectEditar(false)(pacienteDispatch);
      }
    }
  };

  // Cargar grupo familiar al iniciar
  useEffect(() => {
    wsGetGrupoFamiliar(true)(grupoFamiliarDispatch);
    //eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}

      {/* HEADER BAR DE PORTAL  */}
      <Loading
        dataLoading={pacienteState.paciente.loading}
        color="c-white"
        descripcion={"Cargando perfil..."}
      />
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Mi Perfil"} />

      {pacienteState.paciente.datosActualizados && (
        <BodyContainer>
          <Sidebar />
          <ContainerScroll className="containerScroll">
            {/* Botón Volver - solo visible en mobile cuando no hay sidebar */}
            {/* <BtnVolver to="/autocheckin" label="Volver" /> */}
            <motion.div
              variants={pageContainerVariants(esMobile)}
              initial="hidden"
              animate="visible"
              exit="exit"
              className={"ptur-perfil-bodyContainer"}
            >
              <div className="ptur-perfil-usuario">
                {/* Selector de familiares */}
                <div className="ptur-perfil-selector-familiar">
                  <div className="ptur-perfil-selector-familiar-content">
                    <span className="ptur-perfil-selector-familiar-label rb18m">
                      Ver Perfil:
                    </span>
                    <div className="ptur-perfil-selector-familiar-dropdown">
                      <Dropdown
                        onChange={onPerfilFamiliaresChange}
                        campoCodigo="id"
                        descripcion="nombre"
                        valor={
                          !pacienteState.paciente.userSelect
                            .pacienteSeleccionado
                            ? pacienteAuth?.codigo ?? ""
                            : pacienteState.paciente.userSelect
                                .pacienteSeleccionado.id
                        }
                        datos={dropdownFamiliares(
                          listaFamiliaresState,
                          authState,
                          "EditarPerfil"
                        )}
                        heightLista={"auto"}
                        mantenerValorAlCerrar={true}
                      />
                    </div>
                  </div>
                  <hr className="ptur-perfil-lineaSeparadora" />
                </div>
                <div className="ptur-perfil-usuario-box">
                  <div
                    className={`ptur-perfil-usuario-boxBanner ${modificaPerfilClass}`}
                  >
                    <div
                      className={`ptur-perfil-header ${modificaHeadBannerClass}`}
                    >
                      <div className="ptur-perfil-header-imgNombre-box">
                        <div className="ptur-perfil-header-imgNombre-img">
                          <img
                            id="ptur-perfil-datos-foto"
                            src={
                              imgPerfil === null ||
                              imgPerfil === "" ||
                              imgPerfil === undefined
                                ? defaultPerfil
                                : `data:image/jpeg;base64,${imgPerfil}`
                            }
                            alt="Perfil"
                          />
                          <div
                            className={`ptur-perfil-header-cameraIcon-box ${
                              pacienteState.paciente.cambioClave === true ||
                              pacienteState.paciente.editaPerfil.estado === true
                                ? "bgc-grey65"
                                : "bgc-latex30"
                            } pointer`}
                            htmlFor="input2"
                          >
                            <div
                              className="ptur-perfil-header-cameraIcon-icon"
                              htmlFor="input2"
                              onClick={modalCambioDeImagen}
                            >
                              <CameraIcon />
                            </div>
                          </div>
                        </div>
                        <div className="ptur-perfil-header-imgNombre-nombre">
                          <span className="ptur-perfil-datos-nombre rb24t">
                            {nameCamelized()}{" "}
                          </span>
                        </div>
                      </div>
                      {guardarPerfil ? (
                        <div className="ptur-perfil-datos-boxBtns">
                          <button
                            className="ptur-perfil-datos-cancelarBtn rb18m"
                            onClick={EditarPerfil}
                          >
                            <span className="ptur-perfil-datos-cancelarTexto">
                              Cancelar
                            </span>
                          </button>
                          <button
                            className="ptur-perfil-datos-guardarBtn rb18m"
                            onClick={guardarCambiosPerfil}
                          >
                            {pacienteState.paciente.loading ? (
                              <span className="ptur-perfil-datos-loading">
                                <IonSpinner name="lines" />
                              </span>
                            ) : (
                              <span className="ptur-perfil-datos-guardarTexto">
                                Guardar
                              </span>
                            )}
                          </button>
                        </div>
                      ) : (
                        <button
                          className={`ptur-perfil-datos-editarBtn ${
                            pacienteState.paciente.cambioClave === true
                              ? "c-grey45"
                              : "c-latex30"
                          } rb18m`}
                          onClick={EditarPerfil}
                          disabled={pacienteState.paciente.cambioClave}
                        >
                          <EditarMobileIcon
                            color={
                              pacienteState.paciente.cambioClave === true
                                ? "var(--color-grey45)"
                                : "var(--color-latex30)"
                            }
                          />
                          <span className="ptur-perfil-datos-editarTexto">
                            Editar
                          </span>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="ptur-perfil-usuario-box-columna1">
                    <ProfileColumn1 />
                  </div>
                </div>
              </div>
              <div className="ptur-perfil-usuario-boxMobile-datosPersonales">
                <CardPerfil />
              </div>
              <div className="ptur-perfil-usuario-box-columna3">
                <div className="ptur-perfil-usuario-boxMobile-familiar">
                  <CardFamiliar />
                </div>
                {pacienteState.paciente.userSelect.pacienteSeleccionado ===
                  false ||
                pacienteState.paciente.userSelect.pacienteSeleccionado ===
                  null ? (
                  <div className="ptur-perfil-usuario-boxMobile-social">
                    <CardSocial
                      onClickVinculaGoogle={onClickVinculaGoogle}
                      desvincularGoogle={desvincularGoogle}
                      onClickVinculaApple={onClickVinculaApple}
                      desvincularApple={desvincularApple}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="ptur-perfil-usuario-boxMobile-notificaciones">
                  <CardNotificaciones onClickAceptaWsp={onClickAceptaWsp} />
                </div>
                <div className="ptur-perfil-usuario-boxMobile-agregarFamiliar">
                  <CardFamiliar
                    handleClickAgregaFamiliar={handleClickAgregaFamiliar}
                  />
                </div>
                <div className="ptur-perfil-usuario-boxMobile-blanKspace"></div>
              </div>
            </motion.div>
          </ContainerScroll>
        </BodyContainer>
      )}
    </React.Fragment>
  );
};

export default Perfil;
